import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Mail, AlertCircle } from 'lucide-react';

const IntakeSuccess = () => {
  return (
    <div className="page-intake-success">
      <div className="success-container">
        <div className="success-card">
          <div className="success-icon-wrapper">
            <CheckCircle className="success-icon" />
          </div>
          
          <h1 className="heading-1">Intake Received</h1>
          <p className="body-large success-subtitle">
            Thank you for completing your intake form. We've received your information and will be in touch soon.
          </p>

          <div className="success-next-steps">
            <div className="success-step">
              <Mail className="step-icon" />
              <div className="step-content">
                <h3 className="body-regular step-title">What Happens Next</h3>
                <p className="body-small">
                  A licensed provider will review your intake within 1 business day. We'll send you an email with next steps, which may include scheduling your initial consultation or requesting additional information.
                </p>
              </div>
            </div>
          </div>

          <div className="success-disclaimer">
            <AlertCircle className="disclaimer-icon" />
            <div className="disclaimer-content">
              <h4 className="body-small disclaimer-title">Important Safety Information</h4>
              <p className="body-small">
                If you are experiencing a medical emergency or urgent symptoms, please call 911 or visit your nearest emergency room immediately. This intake does not provide immediate medical care.
              </p>
            </div>
          </div>

          <div className="success-actions">
            <Link to="/">
              <button className="btn-primary">Return to Home</button>
            </Link>
            <Link to="/contact">
              <button className="btn-secondary">Contact Support</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntakeSuccess;
